import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

@Pipe({ name: 'roncurrency' })
export class RonCurrencyPipe implements PipeTransform {
  transform(value?: number, currencyCode = 'RON', digits = 2, locale = 'ro'): string | null {
    return formatCurrency(value || 0, locale, getCurrencySymbol(currencyCode, 'wide'), currencyCode, `1.2-${digits}`);
  }
}
